export const excludedPresenters = ['streamgo', '[non-pres]', 'sg_vm'];
export const excludedAudioPresenters = ['streamgo', '[non-pres]'];

export const prerollUrl =
  'https://cdn-aws.s3.eu-west-1.amazonaws.com/webcamGo/langs/[[locale]]/preroll.mp4';
export const postrollUrl =
  'https://cdn-aws.s3.eu-west-1.amazonaws.com/webcamGo/langs/[[locale]]/eventPostRoll.mp4';
